exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .brush-1 {\n    opacity: 0.1;\n  }\n\n  .brush-2 {\n    fill: #72cac2;\n  }\n\n  .brush-3 {\n    fill: #fff;\n  }\n\n  .brush-4 {\n    fill: #ee7470;\n  }\n\n  .brush-5 {\n    fill: #1e4e69;\n  }\n\n  .brush-6 {\n    fill: #f3586a;\n  }\n", ""]);
